module.exports = __webpack_public_path__ + "static/media/doctor6.35ae5edd.png";